import {Component, OnInit} from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';
import {Parametrage, ParametrageService} from '../parametrage';
import {Response} from '@angular/http';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'jhi-faq',
    templateUrl: './faq.component.html'
})
export class FaqComponent implements OnInit {
    parametrages: Parametrage[] = [];
    currentLang: string;
    parametrage: Parametrage;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private translate: TranslateService,
        private parametrageService: ParametrageService
    ) {
        this.jhiLanguageService.setLocations(['global', 'faq']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.parametrageService.queryPageFaq().subscribe(
            (res: Response) => {
                this.parametrages = res.json();
                this.parametrage = this.parametrages[0];
            });
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/faq/faq.component.ts